import { useContext } from "react";

import { LayoutContext } from "components/navigation/Layout";

export const useLayoutContext = () => useContext(LayoutContext);
